import React from "react";
import portfolioimage from "../Assets/Images/portfolio2.png";
import "./Portfolio.css";
import { BsArrowRightShort } from 'react-icons/bs';
import Portfolionum from "./Portfolionum";
import { Link as LinkR } from "react-router-dom";
// import Lottie from 'react-lottie-player';
// import lottie from '../Assets/Images/lotties/portfolio.json';

function Portfolio() {

  return (
    <div id="Portfolio" className="Portfolio-container" >
      <div style={{ fontSize: 20, fontWeight: 500, textAlign: "center", color: "#1E978C" }}> Portfolio</div>
      <h1>Portfolio Showcase</h1>

      <div className="About-text-img">
        <img className="aboutimage" src={portfolioimage} alt="About" />
        {/* <Lottie play animationData={lottie} loop style={{ height: 400, width: 600 }} /> */}

        <div className="portfolio-para">
          <div style={{ fontSize: 20, fontWeight: 500, color: "#1E978C" }}>Smart, Reliable AI-generated Solutions for Speed and High Availability</div>
          <div className="h1">Quality Software Solutions</div>
          <br /><div className="portfolio-para-2">AI-powered, we design and deploy high-quality, scalable web and mobile applications across industries. At Aizonix Solutions, we blend strategy with innovation—delivering secure, powerful digital solutions that simply work, keeping  your business running smoothly and efficiently.</div><br />
            {/*/MyPortfolio*/}
          <LinkR to='MyPortfolio'>
            <button className='button' >Portfolio<BsArrowRightShort /> </button>
          </LinkR>
        </div>
      </div>
      <Portfolionum />
    </div>
  );
}

export default Portfolio;
